<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconGroup_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconGroup_16__a)">
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M10.534 7.943c1.599 0 2.9-1.301 2.9-2.9a2.903 2.903 0 0 0-2.9-2.899 2.903 2.903 0 0 0-2.9 2.899c0 1.599 1.301 2.9 2.9 2.9M6.138 6.227c0 1.16-.944 2.104-2.104 2.104A2.107 2.107 0 0 1 1.93 6.226c0-1.159.944-2.102 2.104-2.102s2.104.943 2.104 2.103M.575 10.268C1.12 9.673 2.156 9.23 4.034 9.23a8.3 8.3 0 0 1 1.64.147 4 4 0 0 0-.662.579c-.276.3-.703.805-.894 1.814a4 4 0 0 0-.035.23H.643a.575.575 0 0 1-.568-.658c.1-.64.339-.899.486-1.059zm9.96-1.086c2.566 0 3.992.601 4.748 1.41l.014.016c.218.233.555.594.694 1.484a.792.792 0 0 1-.782.908H5.86a.79.79 0 0 1-.781-.908c.137-.879.465-1.236.668-1.457l.021-.023c.751-.819 2.179-1.43 4.767-1.43"
            clip-rule="evenodd"
        />
    </g>
    <defs>
        <clipPath id="IconGroup_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
